export default "__VITE_ASSET__CorQFqXq__"